import React, { useEffect, useState } from "react";
import bgimage from "../../assets/game/background.png";
import rock from "../../assets/game/rock.png";
import characterImage from "../../assets/game/character.png";
import NextPage from "../../assets/game/Next Arrow Button.gif";
import BackPage from "../../assets/game/BackArrow.gif";
import KnowMore from "../../assets/game/Know More.png";
import Bronze from "../../assets/game/loyalty rewards/bronzeL.png";
import Sliver from "../../assets/game/loyalty rewards/Sliver.png";
import SliverLocked from "../../assets/game/loyalty rewards/sliverL.png";
import Gold from "../../assets/game/loyalty rewards/Gold.png";
import GoldLocked from "../../assets/game/loyalty rewards/GoldL.png";
import Platinum from "../../assets/game/loyalty rewards/Platinum.png";
import PlatinumLocked from "../../assets/game/loyalty rewards/sliverL.png";
import BackArrow from "../../assets/game/backArrow.png";
import NextArrow from "../../assets/game/NextArrow.png";
import flagImage from "../../assets/game/targetFlag.png";
import Gift from "../../assets/game/gift.png";
import Board from "../../assets/game/offerBoard.png";
import pathFill from "../../assets/game/pathF.png";
import pathEmpty from "../../assets/game/pathE.png";
import Clock from "../../assets/game/clock.png";
import path1 from "../../assets/game/path1.png";
import path2 from "../../assets/game/path2.png";
import path3 from "../../assets/game/path3.png";
import path4 from "../../assets/game/path4.png";
import path5 from "../../assets/game/pathF.png";
import path0 from "../../assets/game/path0.png";
import { useNavigate } from "react-router-dom";

// ─────────────────────────────────────────────
// CONSTANTS
// ─────────────────────────────────────────────
const rocks = [
  { top: "64%", left: "7%" },
  { top: "32%", left: "20%" },
  { top: "64%", left: "41%" },
  { top: "32%", left: "60%" },
  { top: "64%", left: "77%" },
];

const MILESTONES_PER_PAGE = 5; // always fixed

// ─────────────────────────────────────────────
// REWARD LABEL HELPER
// ─────────────────────────────────────────────
const RewardLabel = ({ milestone }) => {
  const { rewardType, value } = milestone;
  const isCashback = rewardType === "cashback";
  const isDiscount = rewardType === "discount";

  return (
    <span
      style={{
        position: "absolute",
        top: "33%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "2.5vw",
        textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
        fontFamily: "Roboto, sans-serif",
        pointerEvents: "none",
      }}
    >
      {isCashback && "₹"}
      {isCashback ? Number(value).toFixed(2) : Number(value)}
      {isDiscount && "%"} {isCashback ? "Cashback" : rewardType}
    </span>
  );
};

// ─────────────────────────────────────────────
// GIFT_ COMPONENT
// ─────────────────────────────────────────────
const Gift_ = ({ milestones, currentPage }) => {
  const giftPositions = [
    { top: "67%", left: "17%" },
    { top: "35%", left: "30%" },
    { top: "67%", left: "51%" },
    { top: "35%", left: "70%" },
    { top: "67%", left: "85%" },
  ];

  const startMilestone = (currentPage - 1) * MILESTONES_PER_PAGE + 1;
  const endMilestone = startMilestone + MILESTONES_PER_PAGE - 1;

  return (
    <>
      {milestones.map((milestone, index) => {
        const { milestoneCount, isSurprise, isRedeemed } = milestone;

        if (
          isSurprise === true &&
          isRedeemed === false &&
          milestoneCount >= startMilestone &&
          milestoneCount <= endMilestone
        ) {
          const pos = giftPositions[(milestoneCount - 1) % MILESTONES_PER_PAGE];
          if (!pos) return null;

          return (
            <img
              key={index}
              src={Gift}
              alt={`Gift ${milestoneCount}`}
              style={{
                position: "absolute",
                top: pos.top,
                left: pos.left,
                width: "15vw",
                height: "auto",
                transform: "translate(-50%, -50%)",
              }}
            />
          );
        }
        return null;
      })}
    </>
  );
};

// ─────────────────────────────────────────────
// BOARD_ COMPONENT
// ─────────────────────────────────────────────
const Board_ = ({ milestones, currentPage }) => {
  const boardPositions = [
    { top: "65%", left: "12%" },
    { top: "31%", left: "30%" },
    { top: "65%", left: "51%" },
    { top: "31%", left: "70%" },
    { top: "65%", left: "90%" },
  ];

  const startMilestone = (currentPage - 1) * MILESTONES_PER_PAGE + 1;
  const endMilestone = startMilestone + MILESTONES_PER_PAGE - 1;

  return (
    <>
      {milestones.map((milestone, index) => {
        const { milestoneCount, isSurprise, isRedeemed } = milestone;

        // Show board for: surprise+redeemed, non-surprise+redeemed, non-surprise+unredeemed
        const shouldShow =
          (isSurprise === true && isRedeemed === true) ||
          (isSurprise === false && isRedeemed === true) ||
          (isSurprise === false && isRedeemed === false);

        if (
          shouldShow &&
          milestoneCount >= startMilestone &&
          milestoneCount <= endMilestone
        ) {
          const pos = boardPositions[(milestoneCount - 1) % MILESTONES_PER_PAGE];
          if (!pos) return null;

          return (
            <div
              key={index}
              style={{
                position: "absolute",
                top: pos.top,
                left: pos.left,
                transform: "translate(-50%, -50%)",
                width: "15vw",
                textAlign: "center",
              }}
            >
              <img
                src={Board}
                alt={`Board ${milestoneCount}`}
                style={{ width: "100%", height: "auto", display: "block" }}
              />
              <RewardLabel milestone={milestone} />
            </div>
          );
        }

        return null;
      })}
    </>
  );
};

// ─────────────────────────────────────────────
// FLAG_ COMPONENT
// ─────────────────────────────────────────────
const Flag_ = ({ currentPage, totalMilestones }) => {
  const isLastPage = currentPage === totalMilestones / MILESTONES_PER_PAGE;
  if (!isLastPage) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: "70%",
        left: "96%",
        transform: "translate(-50%, -50%)",
        width: "11vw",
        textAlign: "center",
      }}
    >
      <img
        src={flagImage}
        alt="Flag"
        style={{ width: "100%", height: "auto", display: "block" }}
      />
    </div>
  );
};

// ─────────────────────────────────────────────
// CHARACTER COMPONENT
// ─────────────────────────────────────────────
const Character = ({ currentPage, currentLevelMilestoneCount }) => {
  const CHARACTER_POSITIONS = [
    { top: "71%", left: "5%"  },
    { top: "57%", left: "24%" },
    { top: "62%", left: "37%" },
    { top: "59%", left: "62%" },
    { top: "61%", left: "77%" },
    { top: "65%", left: "90%" },
  ];

  // ✅ FIX: when count is 0 (level just started / reset),
  // always show character at the fixed start position for ALL levels
  if (currentLevelMilestoneCount === 0) {
    const startPos = { top: "73%", left: "3%" };
    return (
      <div
        style={{
          position: "absolute",
          top: startPos.top,
          left: startPos.left,
          transform: "translate(-50%, -50%)",
          width: "13vw",
          textAlign: "center",
        }}
      >
        <img
          src={characterImage}
          alt="Character"
          style={{ width: "100%", height: "auto", display: "block" }}
        />
      </div>
    );
  }

  // For count > 0: only render if character falls on the current page
  const startMilestone = (currentPage - 1) * MILESTONES_PER_PAGE + 1;
  const endMilestone = startMilestone + MILESTONES_PER_PAGE - 1;

  if (
    currentLevelMilestoneCount < startMilestone ||
    currentLevelMilestoneCount > endMilestone
  ) {
    return null; // character is on a different page
  }

  const characterPosition =
    ((currentLevelMilestoneCount - 1) % MILESTONES_PER_PAGE) + 1;
  const pos = CHARACTER_POSITIONS[characterPosition];
  if (!pos) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: pos.top,
        left: pos.left,
        transform: "translate(-50%, -50%)",
        width: "13vw",
        textAlign: "center",
        transition: "top 0.4s ease, left 0.4s ease",
      }}
    >
      <img
        src={characterImage}
        alt="Character"
        style={{ width: "100%", height: "auto", display: "block" }}
      />
    </div>
  );
};

// ─────────────────────────────────────────────
// MEDAL COMPONENT
// ─────────────────────────────────────────────
const Medal = ({ levelId, daysLeft }) => {
  const [allModelShow, setAllModelShow] = useState(false);

  return (
    <>
      <div
        style={{
          height: "10vw",
          position: "absolute",
          top: "12px",
          display: "flex",
        }}
      >
        <div style={{ display: "flex", padding: "5%", alignItems: "center" }}>
          {/* Bronze — always unlocked */}
          <div>
            <img src={Bronze} style={{ padding: "5%", width: "10vw" }} alt="Bronze" />
            <h1 style={{ fontFamily: "Roboto", fontSize: "12px", fontWeight: "700", marginTop: "-5px", color: "black" }}>
              Bronze
            </h1>
          </div>

          {/* Silver */}
          <div>
            <img
              src={levelId >= 2 ? Sliver : SliverLocked}
              style={{ width: "10vw", padding: "5%" }}
              alt="Silver"
            />
            <h1 style={{ fontFamily: "Roboto", fontSize: "12px", fontWeight: "700", marginTop: "-3px", color: "black", marginLeft: "4px" }}>
              Silver
            </h1>
          </div>

          {/* Gold — hidden until expanded */}
          <div
            style={{
              width: "10vw",
              display: allModelShow ? "block" : "none",
              opacity: allModelShow ? 1 : 0,
              transition: "opacity 0.5s ease-in-out",
            }}
          >
            <img
              src={levelId >= 3 ? Gold : GoldLocked}
              style={{ padding: "5%", width: "100%" }}
              alt="Gold"
            />
            <h1 style={{ fontFamily: "Roboto", fontSize: "12px", fontWeight: "700", color: "black", marginLeft: "2px" }}>
              Gold
            </h1>
          </div>

          {/* Platinum — hidden until expanded */}
          <div
            style={{
              width: "10vw",
              display: allModelShow ? "block" : "none",
              opacity: allModelShow ? 1 : 0,
              transition: "opacity 0.5s ease-in-out",
            }}
          >
            <img
              src={levelId >= 4 ? Platinum : PlatinumLocked}
              style={{ padding: "5%", width: "100%" }}
              alt="Platinum"
            />
            <h1 style={{ fontFamily: "Roboto", fontSize: "12px", fontWeight: "700", color: "black", marginTop: "-2px" }}>
              Platinum
            </h1>
          </div>

          {/* Toggle arrow */}
          <div
            style={{
              width: "5vw",
              display: "flex",
              marginTop: "-5px",
              cursor: "pointer",
            }}
            onClick={() => setAllModelShow((prev) => !prev)}
          >
            <img
              src={allModelShow ? BackArrow : NextArrow}
              style={{ width: "100%" }}
              alt={allModelShow ? "Collapse" : "Expand"}
            />
          </div>
        </div>
      </div>

      {/* Days left clock */}
      <div style={{ position: "absolute", right: "0", top: "1vw" }}>
        <img src={Clock} style={{ width: "100px" }} alt="Clock" />
        <h2
          style={{
            color: "white",
            textAlign: "center",
            position: "absolute",
            top: "0",
            right: "8px",
            fontWeight: "bold",
            fontSize: "16px",
            lineHeight: "20px",
          }}
        >
          Days <br />
          {daysLeft} Left
        </h2>
      </div>
    </>
  );
};

// ─────────────────────────────────────────────
// MAIN GAME COMPONENT
// ─────────────────────────────────────────────
const Game = ({ data, route, tagOrder, setGameguidelines }) => {
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [currentLevelMilestoneCount, setCurrentLevelMilestoneCount] = useState(0);
  const [levelRewards, setLevelReward] = useState([]);
  const [levelId, setLevelId] = useState(1);
  const [daysLeft, setDaysLeft] = useState(1);

  useEffect(() => {
    if (data?.currentLevelMilestoneCount !== undefined) {
      setCurrentLevelMilestoneCount(data.currentLevelMilestoneCount);
      setCurrentPage(
        data.currentLevelMilestoneCount === 0
          ? 1
          : Math.ceil(data.currentLevelMilestoneCount / MILESTONES_PER_PAGE)
      );
    }
    if (data?.levelId) setLevelId(data.levelId);
    if (data?.daysLeft) setDaysLeft(data.daysLeft);
    if (data?.levelRewards) setLevelReward(data.levelRewards);
  }, [data]);

  const totalMilestones = data?.totalMilestones || 0;
  const totalPages = Math.ceil(totalMilestones / MILESTONES_PER_PAGE);
  const startNumber = (currentPage - 1) * rocks.length + 1;
  const isLastPage = currentPage === totalMilestones / MILESTONES_PER_PAGE;

  // ── Path image ──────────────────────────────
  const partialPaths = [path0, path1, path2, path3, path4, path5];

  const getPagePathImage = () => {
    const currentMilestonePage = Math.ceil(
      currentLevelMilestoneCount / MILESTONES_PER_PAGE
    );

    if (currentLevelMilestoneCount >= totalMilestones) return pathFill;
    if (currentPage < currentMilestonePage) return pathFill;
    if (currentPage > currentMilestonePage) return pathEmpty;

    const index =
      currentLevelMilestoneCount === 0
        ? 0
        : ((currentLevelMilestoneCount - 1) % MILESTONES_PER_PAGE) + 1;

    return partialPaths[index] || pathEmpty;
  };

  // ── Navigation ──────────────────────────────
  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((p) => p + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage((p) => p - 1);
  };

  const handleKnowMore = () => {
    if (tagOrder) {
      setGameguidelines(true);
    } else {
      navigate("/guideLines?tagOrder=true");
    }
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        aspectRatio: "16/12",
        overflow: "hidden",
        marginBottom: "3vw",
        borderRadius: "10px",
      }}
    >
      {/* Background */}
      <img
        src={bgimage}
        alt="Background"
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />

      {/* Path overlay */}
      <img
        src={getPagePathImage()}
        alt="Path"
        style={{
          position: "absolute",
          top: "41%",
          left: 0,
          width: "100%",
          height: "auto",
        }}
      />

      {/* Medal + Days Left */}
      <Medal levelId={levelId} daysLeft={daysLeft} />

      {/* Gifts (surprise, unredeemed) */}
      <Gift_ milestones={levelRewards} currentPage={currentPage} />

      {/* Boards (redeemed or non-surprise) */}
      <Board_ milestones={levelRewards} currentPage={currentPage} />

      {/* Character */}
      <Character
        currentPage={currentPage}
        currentLevelMilestoneCount={currentLevelMilestoneCount}
      />

      {/* Flag on last page */}
      <Flag_ currentPage={currentPage} totalMilestones={totalMilestones} />

      {/* Numbered rocks */}
      {rocks.map((pos, index) => (
        <div
          key={index}
          style={{
            position: "absolute",
            top: pos.top,
            left: pos.left,
            width: "18vw",
            height: "18vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={rock}
            alt={`Rock ${index + 1}`}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
          <span
            style={{
              position: "absolute",
              color: "#fff",
              fontWeight: "bold",
              fontSize: "6vw",
            }}
          >
            {startNumber + index}
          </span>
        </div>
      ))}

      {/* Know More */}
      <img
        onClick={handleKnowMore}
        src={KnowMore}
        alt="Know More"
        style={{
          position: "absolute",
          right: "0%",
          bottom: "0%",
          width: "25%",
          cursor: "pointer",
        }}
      />

      {/* Prev button */}
      {currentPage > 1 && (
        <img
          src={BackPage}
          alt="Previous"
          onClick={handlePrev}
          style={{
            position: "absolute",
            left: "-4%",
            top: "37%",
            width: "20%",
            cursor: "pointer",
          }}
        />
      )}

      {/* Next button */}
      {!isLastPage && (
        <img
          src={NextPage}
          alt="Next"
          onClick={handleNext}
          style={{
            position: "absolute",
            right: "-4%",
            top: "37%",
            width: "20%",
            cursor: "pointer",
          }}
        />
      )}
    </div>
  );
};

export default Game;